<template>
  <div style="position: absolute;left:0;top:0;height:0;width:0;overflow:hidden;z-index:-9999;">
    <div :id="`printContent_${uid}`" style="display: table;width: 100%;">
      <component :is="template" v-if="list.indexOf(template) !=-1" :print-data="printData" />
    </div>
  </div>
</template>

<script>
import printJS from 'print-js'
export default {
  name: 'UmPrint',
  components: {
    json: () => import('./template/json'),
  },
  props: {},
  data() {
    return {
      uid: '',
      list: [
        'json',
      ],
      printData: [
        {
          name: 'John Doe',
          email: 'john@doe.com',
          phone: '111-111-1111'
        },
        {
          name: 'Barry Allen',
          email: 'barry@flash.com',
          phone: '222-222-2222'
        },
        {
          name: 'Cool Dude',
          email: 'cool@dude.com',
          phone: '333-333-3333'
        }
      ],
      template: 'json' // 打印模板
    }
  },
  created() {
    this.uid = this._uid
  },
  mounted() {
    this.$nextTick(() => {
      console.log(this)
      this.print()
    })
  },
  methods: {
    print() {
      setTimeout(() => {
        printJS({
          printable: `printContent_${this.uid}`,
          type: 'html',
          scanStyles: false,
          style: '',
          header: '',
          showModal: false,
          targetStyles: ['*'],
          onPrintDialogClose: () => {
            this.handleAfterLeave()
          }
        })
      }, 100)
    },
    handleAfterLeave() {
      this.$destroy(true)
      this.$el.parentNode.removeChild(this.$el)
    }
  }
}
</script>

<style lang="scss" >

</style>
